import styled from '@emotion/styled';

export const MailScroller = styled.div`
  height: calc(100vh - 254px);
  border-radius: 16px;
  padding: 10px 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray};
`;
